<template>
    <st-dropdown-item-styled @click="clickHandler">
        {{ label }}
    </st-dropdown-item-styled>
</template>
<script>
import styled from "vue-styled-components";

const props = {};

const StDropdownItemStyled = styled("div", props)`
    padding: 1.5rem 2.4rem 1.5rem 1.6rem;
    width: 100%;

    background-color: #ffffff;

    &:hover {
        background-color: ${props => props.theme.color.hover};
    }
`;

export default {
    name: "StDropdownItem",
    props: {
        title: String,
        item: Object,
        label: String,
        onHandler: Function
    },
    methods: {
        clickHandler() {
            this.onHandler && this.onHandler();
        }
    },
    components: {
        StDropdownItemStyled
    }
};
</script>
